module.exports = __webpack_public_path__ + "img/48600.e81654f2.jpg";